function displayLabel(label) {
  return String(label || "").replace(/^Wardrobe Demo\s+/i, "").trim();
}

function TextureSwatch({ texture, selected, onClick }) {
  const label = displayLabel(texture.label);

  return (
    <div className="vmwc-texture-swatch">
      <button
        type="button"
        onClick={onClick}
        title={label}
        className={`vmwc-texture-button ${selected ? "is-selected" : ""}`}
      >
        <img
          src={texture.thumbnail ?? texture.path}
          alt={label}
          className="vmwc-texture-image"
        />
      </button>
      <span className="vmwc-texture-label">{label}</span>
    </div>
  );
}

export default function TextureGrid({
  textures,
  selectedId,
  onSelect,
  cols = 5,
}) {
  return (
    <div className="vmwc-texture-grid" data-columns={cols}>
      {textures.map((tex) => (
        <TextureSwatch
          key={tex.id}
          texture={tex}
          selected={selectedId === tex.id}
          onClick={() => onSelect(tex)}
        />
      ))}
    </div>
  );
}
